import { render, staticRenderFns } from "./ModalWorkflowNovoArtefato.vue?vue&type=template&id=5afcd01e&scoped=true"
import script from "./ModalWorkflowNovoArtefato.vue?vue&type=script&lang=js"
export * from "./ModalWorkflowNovoArtefato.vue?vue&type=script&lang=js"
import style0 from "./ModalWorkflowNovoArtefato.vue?vue&type=style&index=0&id=5afcd01e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afcd01e",
  null
  
)

export default component.exports